import { useEffect, useState } from "react";
import api from "@/lib/api";

export function useCalendarEvents(start, end) {
  const [data, setData] = useState({ events: [], rooms: [] });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setLoading(true);
    api.get("/bookings/calendar", { params: { start, end } })
      .then((r) => setData(r.data)).catch(() => setData({ events: [], rooms: [] }))
      .finally(() => setLoading(false));
  }, [start, end]);
  return { ...data, loading };
}
